import styled from 'styled-components';

export const PredictionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 100%;

  @media (max-width: 1800px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const FilterWrapper = styled.div`
  margin-bottom: 24px;
`;
